import React from 'react';
import './WhyChooseUs.css';

const reasons = [
  {
    num: '01',
    icon: '🎯',
    title: 'Personalised Learning Plans',
    desc: 'Every child receives a fully customised plan. We assess their unique learning style, pace, and challenges before designing a programme — not a generic template.',
    color: '#60a5fa',
  },
  {
    num: '02',
    icon: '🧠',
    title: 'Certified in Psychology & Special Education',
    desc: 'Led by a founder with M.Sc Psychology, PG Diplomas in Learning Disability and Counselling, and 15+ years of hands-on experience across schools and organisations.',
    color: '#a78bfa',
  },
  {
    num: '03',
    icon: '👨‍👩‍👧',
    title: 'Parent-Involved at Every Step',
    desc: 'We don\'t just work with the child — we work with the family. Regular parent counselling sessions ensure support continues at home, not only in the classroom.',
    color: '#34d399',
  },
  {
    num: '04',
    icon: '💬',
    title: 'Safe, Judgement-Free Environment',
    desc: 'Children and parents speak openly here. We listen without judgement, support without pressure, and make every student feel capable and respected.',
    color: '#fbbf24',
  },
];

const comparison = [
  { point: 'Individual assessment before starting',   akshara: true,  others: false },
  { point: 'Qualified special educator on staff',     akshara: true,  others: false },
  { point: 'Parent counselling included',             akshara: true,  others: false },
  { point: 'Covers learning disabilities & ADHD',    akshara: true,  others: false },
  { point: 'NIOS board exam coaching',                akshara: true,  others: false },
  { point: 'Behaviour therapy support',               akshara: true,  others: false },
];

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export default function WhyChooseUs() {
  return (
    <section className="why-section reveal" id="why">

      {/* ── Top: dark bento grid ── */}
      <div className="why-top">
        <div className="why-top-inner">

          {/* Left anchor panel */}
          <div className="why-anchor">
            <span className="why-badge">Why Akshara</span>
            <h2 className="why-heading">
              What Makes<br />
              Us <span className="why-accent">Different</span>
            </h2>
            <p className="why-intro">
              We are not just another tuition centre. Akshara is a specialised
              learning support centre built around each child's individual needs,
              strengths, and challenges.
            </p>

            {/* Mini stats */}
            <div className="why-stats">
              {[
                { val: '15+', lbl: 'Years' },
                { val: '500+', lbl: 'Students' },
                { val: '10+', lbl: 'Programmes' },
              ].map((s) => (
                <div className="wstat" key={s.lbl}>
                  <span className="wstat-val">{s.val}</span>
                  <span className="wstat-lbl">{s.lbl}</span>
                </div>
              ))}
            </div>

            <button className="why-cta" onClick={() => scrollTo('contact')}>
              Book Free Assessment →
            </button>
          </div>

          {/* Right: reason rows */}
          <div className="why-reasons">
            {reasons.map((r) => (
              <div className="why-row" key={r.num}>
                <div className="why-row-num" style={{ color: r.color }}>
                  {r.num}
                </div>
                <div className="why-row-icon"
                  style={{ background: `${r.color}18` }}>
                  {r.icon}
                </div>
                <div className="why-row-body">
                  <h3 className="why-row-title" style={{ color: r.color }}>
                    {r.title}
                  </h3>
                  <p className="why-row-desc">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* ── Bottom: comparison table ── */}
      <div className="why-bottom">
        <div className="why-bottom-inner">
          <div className="cmp-header">
            <h3 className="cmp-title">Akshara vs. Regular Tuition Centre</h3>
            <p className="cmp-sub">See what sets us apart in a single glance</p>
          </div>

          <div className="cmp-table-wrap">
            <table className="cmp-table">
              <thead>
                <tr>
                  <th className="cmp-th cmp-th-point">What parents want</th>
                  <th className="cmp-th cmp-th-us">
                    <div className="cmp-logo-cell">
                      <span className="cmp-logo-dot" />
                      Akshara
                    </div>
                  </th>
                  <th className="cmp-th cmp-th-other">Other Centres</th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((c, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'cmp-row-even' : ''}>
                    <td className="cmp-td cmp-td-point">{c.point}</td>
                    <td className="cmp-td cmp-td-us">
                      {c.akshara
                        ? <span className="cmp-yes">✓</span>
                        : <span className="cmp-no">✗</span>}
                    </td>
                    <td className="cmp-td cmp-td-other">
                      {c.others
                        ? <span className="cmp-yes">✓</span>
                        : <span className="cmp-no">✗</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </section>
  );
}
